import { User, useUsers } from './useUsers'

export const useSingleUser = (userUid: string | undefined | null): User => {
  const { getUserByUid } = useUsers()

  return getUserByUid(userUid)
}
